import { objectUtils, pricingUtils } from "@flights/web-api-utils-universal";
export const transformPreOptedFlexibleTicket = ({ travellers, priceBreakdown, airProductReference, supplierInfo }) => ({
    price: travellers.length
        ? pricingUtils.sumPriceBreakdown(new Array(travellers.length).fill(priceBreakdown))
        : pricingUtils.getEmptyBreakdown(),
    reference: airProductReference,
    travelerPrices: travellers.map((traveller) => ({
        travellerPriceBreakdown: priceBreakdown,
        travellerReference: traveller
    })),
    supplierInfo
});
export const transformPreOptedCheckedInBaggage = (checkedInBaggage) => {
    const { options, airProductReference } = checkedInBaggage;
    const travelerBaggages = options.flatMap(({ travellers, priceBreakdown, luggageAllowance }) => travellers.map((traveller) => ({
        price: priceBreakdown,
        luggageAllowance,
        traveleRreference: traveller,
        travellerReference: traveller
    })));
    return {
        price: travelerBaggages.length
            ? pricingUtils.sumPriceBreakdown(travelerBaggages.map(({ price }) => price))
            : pricingUtils.getEmptyBreakdown(),
        reference: airProductReference,
        travelerBaggages
    };
};
export const transformPreOptedCancelForAnyReason = ({ priceBreakdown, airProductReference, content, market }) => ({
    price: priceBreakdown,
    reference: airProductReference,
    content,
    market
});
export const transformPreOptedExtras = (preOptedAncillaries, availableAncillaries) => {
    const extraKeys = objectUtils.getObjectKeys(preOptedAncillaries).filter((key) => !!preOptedAncillaries[key]);
    return extraKeys.reduce((acc, extraKey) => {
        if (availableAncillaries[extraKey]) {
            switch (extraKey) {
                case "flexibleTicket":
                    acc.flexibleTicket = transformPreOptedFlexibleTicket(availableAncillaries[extraKey]);
                    break;
                case "checkedInBaggage":
                    acc.checkedInBaggage = transformPreOptedCheckedInBaggage(availableAncillaries[extraKey]);
                    break;
                case "cancelForAnyReason":
                    acc.cancelForAnyReason = transformPreOptedCancelForAnyReason(availableAncillaries[extraKey]);
                    break;
                default:
                    break;
            }
        }
        return acc;
    }, {});
};
